export default __webpack_public_path__ + "static/media/Draw of the Sword.1d6d3d9a.png";